var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[[_c('div',{staticClass:"wrapper"},[(true)?_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.pdfSource,"frameborder":"0","id":"bdIframe"}}):_vm._e()])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }